<template>
  <div style="width: 100%; height: 100%;">
    <template v-if="cardType==='TruthImageCard'">
      <TruthImageCard v-bind="$attrs" :cardID="cardID"/>
    </template>
    <template v-else-if="cardType==='InfoCard'">
      <InfoCard v-bind="$attrs" :cardID="cardID"/>
    </template>
    <template v-else-if="cardType==='PieCard'">
      <PieCard v-bind="$attrs" :cardID="cardID"/>
    </template>
    <template v-else-if="cardType==='MarkerCard'">
      <MarkerCard v-bind="$attrs" :cardID="cardID"/>
    </template>
    <template v-else-if="cardType==='SVGCard'">
      <SVGCard v-bind="$attrs" :cardID="cardID"/>
    </template>
    <template v-else-if="cardType==='StateCard'">
      <StateCard v-bind="$attrs" :cardID="cardID"/>
    </template>
    <template v-else-if="cardType==='ImmuneCard'">
      <ImmuneCard v-bind="$attrs" :cardID="cardID"/>
    </template>
    <template v-else-if="cardType==='TLSGridCard'">
      <TLSGridCard v-bind="$attrs" :cardID="cardID"/>
    </template>
    <template v-else-if="cardType==='TLSMarkerScoreCard'">
      <TLSMarkerScoreCard v-bind="$attrs" :cardID="cardID"/>
    </template>
    <template v-else-if="cardType==='AddNewCard'">
      <AddNewCard/>
    </template>


  </div>
</template>

<script>

import TruthImageCard from "@/components/tools/TruthImageCard";
import InfoCard from "@/components/tools/InfoCard";
import PieCard from "@/components/tools/PieCard";
import MarkerCard from "@/components/tools/MarkerCard";
import AddNewCard from "@/components/tools/AddNewCard";
import SVGCard from "@/components/tools/SVGCard";
import StateCard from "@/components/tools/StateCard";
import ImmuneCard from "@/components/tools/ImmuneCard";
import TLSGridCard from "@/components/tools/TLSGridCard";
import TLSMarkerScoreCard from "@/components/tools/TLSMarkerScoreCard";
export default {
  name: 'CommonCard',
  components: {
    TLSMarkerScoreCard,
    TLSGridCard, ImmuneCard, StateCard, SVGCard, AddNewCard, MarkerCard, PieCard, InfoCard, TruthImageCard},
  props:{
    cardID: String,
    cardType: String,
  },
  data(){
    return{
    }
  },
  mounted() {
  },
  methods:{
    addCard(){
    }
  }
};
</script>
